import { useAuth } from '@app/core/auth/authentication/hooks/useAuth';
import { auditReports } from '@mi-front/api-clients';
import { AodRuleWizard } from './AodRuleWizard';
import { AodRuleWizardValues } from './types';

export function AodCreateRuleWizard() {
  const auth = useAuth();

  const initialData: AodRuleWizardValues = {
    clientId: auth.client!.id,
    basic: {
      name: '',
      reportType: auditReports.AodRuleReportTypeEnum.AUDIT_GIP_STATUS,
      trigger: auditReports.AodRuleTriggerEnum.ORDER_END,
      active: true,
      notificationSettings: {
        policy: auditReports.NotificationSettingsPolicyEnum.ALWAYS,
      },
      managers: [],
    },
    reportConfig: null,
    exportOptions: null,
    exportConditions: null,
  };

  return <AodRuleWizard initialData={initialData} />;
}
